const BASE_PATH = '/agent-wizard';

export const AGENT_WIZARD_ACCOUNT_PATH = `${BASE_PATH}/:accountId`;
export const AGENT_WIZARD_PROJECT_PATH = `${AGENT_WIZARD_ACCOUNT_PATH}/:projectId`;

const AGENT_WIZARD_PATHS = {
  SIGNUP: `${BASE_PATH}/signup`,
  COMPANY: `${BASE_PATH}/company`,
  COMPANY_ACCOUNT: `${AGENT_WIZARD_ACCOUNT_PATH}/company`,
  SURVEY: `${AGENT_WIZARD_PROJECT_PATH}/survey`,
  VOICE: `${AGENT_WIZARD_PROJECT_PATH}/voice`,
  SCENARIOS: `${AGENT_WIZARD_PROJECT_PATH}/scenarios`,
} as const;

export default AGENT_WIZARD_PATHS;
